import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/engineering/page/$page")({
  loader: () => {
    throw redirect({ to: "/labs/research" });
  },
  component: () => null,
});
